<template>
  <div class="copyright">
    &copy; 荞克力慕斯工作室&nbsp;&nbsp;&nbsp;Create by 小红帽工作室
  </div>
</template>

<script>
export default {
  name: 'Copyright',
  data () {
    return {}
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.copyright {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 12px;
  line-height: 1;
  color: #ddd;
  span {
    margin-left: 10px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Copyright/index.vue